module.exports = __webpack_public_path__ + "static/06-39e03503633fbc879d8e7243bf197bdb.jpg";